/* eslint-disable import/prefer-default-export */
import { type QueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/consts/common';

/** Refreshes GET /users/{userUuid} caches, including field-specific keys. */
function invalidateUserRecord(queryClient: QueryClient, userUuid: string) {
  queryClient.invalidateQueries({
    queryKey: [QUERY_KEYS.USER, userUuid],
  });
}

export { invalidateUserRecord };
